import React from "react";

import { images } from "../../constants";
import "./AboutUs.css";

const AboutUs = () => (
	<div>
		<div
			className="app__aboutus app__bg flex__center section__padding"
			id="about"
		>
			<div className="app__aboutus-overlay flex__center">
				<img src={images.M} loading="lazy" alt="M" />
			</div>
			<div className="app__aboutus-content flex__center">
				<div className="app__aboutus-content_about">
					<h1 className="headtext__cormorant">About Us</h1>
					<img
						src={images.spoon}
						className="app__aboutus-content_about-spoon"
						loading="lazy"
						alt="spoon"
					/>
					<p className="p__opensans">
						Mary Matha Catering and Event Management have been at the forefront
						of delivering exceptional catering and event management services.
						With a passion for perfection and a dedication to creating
						unforgettable experiences, we have earned a reputation for
						excellence. Our team of skilled professionals brings together
						creativity, attention to detail, and a commitment to personalized
						service, ensuring that every event is flawlessly executed. Whether
						it's a wedding, corporate function, or special celebration, we go
						above and beyond to make your vision a reality, leaving you and your
						guests with memories that will be cherished for years to come.
					</p>
				</div>
				<div className="app__aboutus-content_knife flex__center ">
					<img src={images.knife} alt="knife" />
				</div>

				<div className="app__aboutus-content_history">
					<h1 className="headtext__cormorant">Our History</h1>
					<img
						src={images.spoon}
						className="app__aboutus-content_history-spoon"
						alt="spoon"
					/>
					<p className="p__opensans">
						Since our establishment in 2013, MMC has embarked on an inspiring
						journey of growth and success in the catering and event management
						industry. With unwavering dedication, we have proven our excellence
						to the people of Anchal, and now we are delighted to extend our
						exceptional services to Kollam and its nearby areas. Our commitment
						to delivering impeccable service and creating unforgettable
						experiences has earned us a trusted reputation. As we continue to
						evolve, we take immense pride in our history of shaping remarkable
						events, exceeding expectations, and leaving a lasting impression.
					</p>
				</div>
			</div>
		</div>
	</div>
);

export default AboutUs;
